<template>
  <div class="home">
    <img class="home-img" :src="activityData.image" alt="">
    <div class="title">{{ activityData.title }}</div>
    <div class="list">
      <a class="item" v-for="item in list" :key="item.title" :href="item.link">
        <img :src="item.image" alt="">
        <div class="item-name">{{ item.title }}</div>
      </a>
    </div>
    <div class="rule" :style="`background-color: ${activityData.themeColor};`" v-if="activityData.intro">
      <h4 :style="`color: ${activityData.themeColor};`">活动规则</h4>
      <div class="intro" v-html="activityData.intro"></div>
    </div>

    <div class="toastad" v-if="activityData.toastad && isShowAd" @click="isShowAd = false">
      <img :src="activityData.toastad" alt="">
    </div>
  </div>
</template>

<script>
import COVER from '@/utils/COVER'
import COVERAPP from '@/utils/COVERAPP'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'Home',
    data() {
        return {
            userinfo: {},
            btnDisabled: false,
            dialogData: null,
            formData: {},
            list: [],
            isShowAd: false,
        }
    },
    props: ['aid', 'activityData'],
    created() {
      this.aid = this.$route.query.id || '';
      const adtime = localStorage.getItem('votelist_adtime_' + this.aid);
      if (!adtime || new Date().getTime() - adtime > 1000 * 60 * 60 * 12) {
        this.isShowAd = true;
        this.$track(this.aid, 'adtoast');
        localStorage.setItem('votelist_adtime_' + this.aid, new Date().getTime());
      }
    },
    mounted() {
        if(COVERAPP.Attribute.isApp() || !this.activityData.isAppShow) {
            this.getUserInfon() 
        }  
        setTimeout(()=> {
            this.setPageLoadingAsync(false);
        }, 500);
        this.formatList() 
    },
    methods: {
        ...mapActions([
			'setPageLoadingAsync'
		]),
        formatList () {
            (this.activityData.list || []).forEach(val => {
                if (this.activityData.isGojjvoteTemplate) {
                    val.link = val.link.replace('/vote/', '/jjvote/')
                }
                this.list.push(val)
            });
        },
        getUserInfon() {
            let _this = this
            if(COVERAPP.Attribute.isApp()) {
                let isLoad_Bridging = setInterval(()=> {
                    try {
                        COVERAPP.Method.GetUser({
                            callback(res) {
                                clearInterval(isLoad_Bridging);
                                let userinfo = JSON.parse(res);
                                if(!COVER.isEmpty(userinfo.user_id)){
                                    _this.userinfo = userinfo;
                                }
                            }
                        });
                    } catch (e) {}
                }, 300) 
            } else {
                COVER.getUser((res) => {
                    _this.userinfo = JSON.parse(JSON.stringify(res));
                })
            }    
        }
    }
}
</script>

<style lang="less" scoped>
.home {
  .home-img {
    width: 100%;
  }
  .title {
    font-size: 5vw;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-weight: bold;
    padding: 3vw 0;
    &:after {
      content: ' ';
      width: 7vw;
      background: #db332a;
      height: 1vw;
      margin: 2vw auto;
    }
  }
  .list {
    padding: 5vw 3vw 0 3vw;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .item {
      width: 100%;
      position: relative;
      margin-bottom: 15vw;
      min-height: 40vw;
      img {
        width: 100%;
        border-radius: 1.5vw;
      }
      .item-name {
        background: white;
        text-align: center;
        font-size: 4vw;
        text-align: center;
        padding: 3.5vw 2vw;
        box-sizing: border-box;
        width: 90%;
        margin: -5vw auto 0 5%;
        background: white;
        font-weight: bold;
        box-shadow: 0 1vw 2vw #e5dcdc;
        position: absolute;
        border-radius: 1.5vw;
        color: black;
      }
    }
  }
  .rule {
    background: #ee2e2e;
    color: white;
    font-size: 3.4vw;
    padding: 5vw 4vw;
    line-height: 1.4em;
    h4 {
      background: white;
      color: #ee2e2e;
      width: 25vw;
      margin: 0 auto;
      text-align: center;
      font-size: 5vw;
      border-radius: 5vw;
      padding: 2vw 3vw;
      line-height: 1.0em;
      margin-bottom: 4vw;
    }
    .intro {
      color: white !important;
    }
  }
  .toastad {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 100;
    top: 0;
    left: 0;
    background: rgba(#000000, .8);
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      animation: antoastad .4s 0s ease forwards;
      transform: scale(.5);
    }
  }
}
@keyframes antoastad {
  0% {
    transform: scale(.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>